import { render } from "./createForm.vue?vue&type=template&id=f7b9a29c&scoped=true"
import script from "./createForm.js?vue&type=script&lang=js"
export * from "./createForm.js?vue&type=script&lang=js"

import "./createForm.vue?vue&type=style&index=0&id=f7b9a29c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7b9a29c"]])

export default __exports__